import React from "react";
import Header from "../../Layouts/Header";
import "./index.css"; // Import the CSS file
import "../../CommonContainer/common.css"
import teamImage from '../../../Assets/images/aboutimages/team.png'; // Replace with your path
import founderImage from '../../../Assets/images/aboutimages/founder-image.png'; // Replace with your path
import journeyImage from "../../../Assets/images/aboutimages/journeyImage.png"
import bannerSubimg from "../../../Assets/images/aboutimages/banner-sub.png"
import ParticleImage from "../../CommonContainer/ParticleImage";

import fimage from "../../../Assets/images/aboutimages/founder-image.png"
import { useNavigate } from "react-router-dom";

import bannerSubimg2 from "../../../Assets/images/articles-img.png"

import aboutimg from "../../../Assets/images/aboutimg.png"



const AboutUs = () => {


    const navigate = useNavigate();

    const contactus = () => {
        navigate("/contact-us")
    }
    return (
        <><div>
            <div className="about-hero-section">
                <Header />
                <div className="common-width-home-main-container">
                    <div className="about-banner1-main-section">
                        <div>
                            <h1>Where Silver Speaks the Language of Legacy</h1>
                            <p>Crafted with care. Rooted in tradition. Designed to last forever</p>
                            <button className="contact-button" onClick={contactus}>Contact Us</button>
                        </div>
                        <img src={aboutimg} alt="banner1" />
                    </div>
                </div>
            </div>

            {/* second section */}
            <div className="sreerasthu-journey-container">
                <div className="image-section">
                    <img src={journeyImage} alt="Sreerasthu Journey" className="journey-image" data-aos="fade-up"
                        data-aos-duration="2000" />
                    {/* <ParticleImage src={journeyImage}   className="journey-image" /> */}
                </div>
                <div className="text-section">
                    <h2 className="heading">The Sreerasthu Journey</h2>
                    <p className="description">
                        Sreerasthu was born from a deep reverence for tradition and a passion for timeless craftsmanship.
                        From intricate gold-polished silver jewelry to majestic furniture and sacred pooja items, we bring
                        together the finest artisanship in 92.5 sterling silver.


                    </p>
                    <p className="description">
                        We believe silver is more than a metal — it's a medium of grace, celebration, and heritage.
                        Our collections are designed to honor that legacy while making it accessible for modern homes and hearts.
                    </p>
                    {/* <button className="explore-btn" onClick={contactus}>Explore</button> */}
                </div>
            </div>
        </div>

            <div className="sreerasthu-about">

                {/* Section 1: Why Choose Sreerasthu */}
                {/* <div className="why-choose-container">
                    <div className="text-side">
                        <h2>Why Choose Sreerasthu</h2>
                        <p>
                            At Sreerasthu, we blend heritage with craftsmanship to offer more than just silver.
                        </p>
                        <p>
                            We offer legacy. Every piece, whether it's gold-polished jewelry, majestic furniture,
                            or divine pooja items, is crafted in certified 92.5 silver with unmatched precision.
                            Rooted in tradition and designed for timeless beauty, Sreerasthu is where purity,
                            elegance, and meaning come together.
                        </p>

                        
                        <button className="explore-btn">Explore</button>
                    </div>
                    <div className="image-side">
                    At Sreerasthu, we blend heritage with craftsmanship to offer more than just silver 

we offer legacy. Every piece, whether it's gold-polished jewelry, majestic furniture, or divine pooja items, is crafted in certified 92.5 silver with unmatched precision. Rooted in tradition and designed for timeless beauty, Sreerasthu is where purity, elegance, and meaning come together.
                        <img src={teamImage} alt="Our Team" />
                    </div>
                </div> */}

                <div className="why-choose-container">

                    <div className="text-section ourjouner">
                        <h2 className="heading">Why Choose Sreerasthu</h2>
                        <p className="description">
                            At Sreerasthu, we blend heritage with craftsmanship to offer more than just silver

                        </p>
                        <p className="description">
                            we offer legacy. Every piece, whether it's gold-polished jewelry, majestic furniture, or divine pooja items,
                            is crafted in certified 92.5 silver with unmatched precision. Rooted in tradition and designed for timeless beauty,
                            Sreerasthu is where purity, elegance, and meaning come together.
                        </p>
                        <button className="explore-btn" onClick={contactus}>Explore</button>
                    </div>
                    <div className="image-section">
                        <img src={teamImage} alt="Sreerasthu Journey" className="journey-image" data-aos="fade-down"
                            data-aos-easing="linear"
                            data-aos-duration="1500" />
                        {/* <ParticleImage src={journeyImage}   className="journey-image" /> */}
                    </div>
                </div>

                {/* Section 2: Founder Overlap Section */}
                <div className="founder-section">
                    <div className="founder-image">
                        <img src={founderImage} alt="Founder" data-aos="fade-zoom-in"
                            data-aos-easing="ease-in-back"
                            data-aos-delay="200"
                            data-aos-offset="0" />
                        {/* <ParticleImage src={journeyImage}   className="journey-image" /> */}
                    </div>
                    <div className="text-section founder-text">
                        <h2 className="heading">Srenik Bavirisetty</h2>
                        <div className="title">Founder & CEO, Sreerasthu</div>
                        <p className="description">
                            At Sreerasthu, we don’t just create silver products — we craft timeless expressions of beauty,
                            culture, and emotion. Every piece we offer carries the soul of tradition and the precision of true craftsmanship.
                            Our goal is to bring the richness of 92.5 sterling silver into everyday living — whether
                            it’s through jewelry that tells your story, furniture that commands presence, or pooja items that inspire devotion.


                        </p>
                        <p className="description">

                            Sreerasthu is a reflection of my passion for heritage, my respect for artisans, and my belief that elegance should be eternal.
                            I welcome you to be a part of this journey.”
                        </p>
                        {/* <button className="explore-btn">Explore</button> */}
                    </div>
                </div>

            </div></>
    );
};

export default AboutUs;
